export const API_URLS = {
  AUTH: {
    SIGNUP: "/auth/signup",
    SIGNIN: "/auth/signin",
    CHECK: "/auth/check",
    PUBLIC_RESEND: "/auth/public-resend",
    GOOGLE_AUTH: "/auth/google",
    MFA_VALIDATE: "/auth/mfa-validate",
    VERIFY_EMAIL: "/auth/verify-email",
    RESET_PASSWORD_SEND_LINK: "/profile/reset-password/send-link",
    RESET_PASSWORD_VALIDATE_LINK: "/profile/reset-password/validate-link",
  },
  SETTING: {
    PROFILE: {},
    SECURITY: {
      STATUS: "/security/status",
      LOGOUT: "/auth/logout",
      MFA_VERIFY: "/auth/mfa-verify",
      MFA_REGISTER: "/auth/mfa-register",
      MFA_TOGGLE: "/auth/mfa-toggle",
      VERIFY_PHONE: "/auth/verify-phone",
      SEND_PHONE_OTP: "/auth/send-phone-verify-otp",
      VERIFY_CHANGE_PHONE: "/auth/verify-change-phone",
      SEND_CHANGE_PHONE_OTP: "/auth/send-change-phone-verify-otp",
      PRIVATE_RESEND: "/auth/private-resend",
      CHANGE_PASSWORD: "/profile/change-password",
      UPDATE_PASSWORD: "/profile/change-password?Key=temp",
    },
  },
  ACTIONS: {
    PASS_CHECK_REQ: "/action/pass-check-req",
    PASS_CHECK: "/action/pass-check",
  },
  PROFILE: {
    GET_INFO: "/profile",
    UPDATE_MY_PROFILE: "/profile/my-profile",
    UPDATE_ORG_PROFILE: "/profile/org-profile",
  },
  DOCS: {
    GET_UPLOAD_URL: "/docs/get-url",
    AND_UPDATE_DOCUMENT: "/profile/documents",
  },
  SIGNATORY_AND_LETTERHEAD: {
    GET_SIGNATARY_AND_LETTER_HEAD: "/profile/signatory-and-letter-heads",
    ADD_UPDATE_SIGNATORY: "profile/signatory-and-letter-heads?key=sig",
    AND_UPDATE_LETTER_HEAD: "profile/signatory-and-letter-heads?key=letter",
  },
  EMPLOYEE: {
    GET_ORGS_EMP: "/employees",
    ADD_EMP: "employee/action?action_typ=add",
    EXIT_EMP: "employee/action?action_typ=exit",
    UPDATE_EMP: "employee/action?action_typ=edit",
    DELETE_EMP: "employee/action?action_typ=delete",
    DELETE_SIG: "employee/action?action_typ=delete-sig",
    ACTION_ATTACHMENT: "attachment-action",
    NOTE_ACTION: "note-action",
    SHARE_EMP: "employee/action?action_typ=share",
    REINVITE: "employee/action?action_typ=re-invite",
    ADD_ATTACHMENT: "employee/add-attachment",
    ADD_NOTE: "employee/add-note",
    INFO: "employee/view",
    CONFIG: "/org/config",
    GLOBAL_QUERY: "employee/global-query",
    IMPORT: "employee/import",
    IMPORT_HISTORY: "employee/import/history",
    WEB_ACCESS: "employee/web-access",
    PLANS: "employee/plans",
  },
  ROLE: {
    ADD: "role/action?action_typ=add",
    EDIT: "role/action?action_typ=edit",
    DELETE: "role/action?action_typ=delete",
    ASSIGN: "role/action?action_typ=assign",
  },
  PERMISSION: {
    UPDATE: "permissions",
  },
  EMPLOYEE_REPORT: {
    CHECKOUT: "/employee-report/checkout",
    DOC_INFO: "/employee-report/info",
    PAYMENT_VALIDATION: "/employee-report/validate-payment",
  },
  NOTIFICATION: {
    LIST: "/user-notification",
    MARK_AS_READ: "/notification/mark-as-read",
    MARK_AS_CLEAR: "/notification/mark-as-clear",
  },
  INTERNAL: {
    DOC_LIST: "product/all-users-docs",
    ORGANISATIONS: {
      LIST: "/organisations/list",
      MANAGE: "/organisations/manage",
      CATEGORIES: "/categories",
    },
  },
  CONFIG: {
    GET: "/config",
    OPTIONS: "/options?optionKey=country_currency",
  },
  EXTERNAL: {
    COUNTRY_LIST: "https://admin.api.lystloc.com/admin-rewrite/country_list",
  },
  DASHBOARD: {
    GET_INFO: "/dashboard",
  },
  PAYMENT: {
    HISTORY: "/payment/history",
    TRANSACTION_DETAILS: "/payment/history",
    DOWNLOAD_INVOICE: "/payment/download-invoice",
    STATS: "/payment/history/stats",
    EXPORT_HISTORY: "/export-history",
    EXPORT_TRANSACTIONS: "/export-history/transactions",
  },
};
